export const AbortReasons = {
  TIMEOUT: 'timeout',
  MANUAL: 'manual',
  ON_UNMOUNT: 'on_unmount',
};